import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { faqSchema, FOUNDER, pageHead, SITE_URL } from "@/lib/seo";

const c = landingPages["montee-en-competences-marketing"]!.fr;
const PATH = "/services/montee-en-competences-marketing";

export const Route = createFileRoute("/services/montee-en-competences-marketing")({
  head: () =>
    pageHead({
      path: PATH,
      title: c.title,
      description: c.description,
      enPath: null,
      crumbs: [["Services", "/services"], ["Montée en compétences", PATH]],
      schemas: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Montée en compétences marketing",
          serviceType: "Formation et coaching marketing",
          description: c.description,
          url: `${SITE_URL}${PATH}`,
          provider: { "@type": "Organization", name: "CMO Partner", url: SITE_URL, founder: FOUNDER },
          areaServed: [
            { "@type": "City", name: "Bordeaux" },
            { "@type": "AdministrativeArea", name: "Gironde" },
            { "@type": "Country", name: "France" },
          ],
        },
        faqSchema(c.faq),
      ],
    }),
  component: () => <LandingPage pageKey="montee-en-competences-marketing" forceLanguage="fr" />,
});
